import { useRef, useEffect } from 'react';
import { AWAIT_PROP_TIMEOUT_SECONDS } from '../const';

export default function usePropTimer({
  onTimeout,
  awaitProp,
  propToAwait,
}: {
  onTimeout: () => void;
  awaitProp: boolean;
  propToAwait?: unknown;
}): void {
  const timerRef = useRef<NodeJS.Timeout>();

  useEffect(() => {
    if (timerRef.current === undefined) {
      timerRef.current = setTimeout(() => {
        if (propToAwait === undefined) {
          onTimeout();
        }
      }, AWAIT_PROP_TIMEOUT_SECONDS * 1000);
    }
  });

  useEffect(() => {
    if (!awaitProp) {
      clearTimeout(timerRef.current);
    }
  });

  useEffect(() => {
    if (propToAwait !== undefined) {
      clearTimeout(timerRef.current);
    }
  });
}
